import { ca } from '@cian/analytics';

interface ITrackNavigationToCard {
  id: number;
}

export function trackNavigationToCard({ id }: ITrackNavigationToCard) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'to_card',
    products: [{ id }],
  });
}
